import { DoqSize, DoqType } from './types';
import { Simple as DoqFaceSimple } from './faces/Simple';
import { Algorithm as DoqFaceAlgorithm } from './faces/Algorithm';
import { Alarm as DoqFaceAlarm } from './faces/Alarm';
import { Locked as DoqFaceLocked } from './faces/Locked';
import { Broadcast as DoqFaceBroadcast } from './faces/Broadcast';
import { Error as DoqFaceError } from './faces/Error';
import { Success as DoqFaceSuccess } from './faces/Success';
import { DependencyMapError as DoqDependencyMapError } from './faces/DependencyMapError';
import { BlockDiagramError as DoqBlockDiagramError } from './faces/BlockDiagramError';
import { RelationshipsError as DoqRelationshipsError } from './faces/RelationshipsError';
import { PageGone as DoqPageGone } from './faces/PageGone';
import { MissingOrg as DoqMissingOrg } from './faces/MissingOrg';
import { ChooseOrg as DoqChooseOrg } from './faces/ChooseOrg';
import { ComponentMergeEmpty as DoqComponentMergeEmpty } from './faces/ComponentMergeEmpty';
import { PageGone as DoqRelationshipsGone } from './faces/RelationshipsGone';
import { DependencyMapGone as DoqDependencyMapGone } from './faces/DependencyMapGone';
import { SpiderChart } from './faces/SpiderChart';
import { DashboardBellySimple } from './faces/DashboardBellySimple';
import { DashboardBellyMissingOrg } from './faces/DashboardBellyMissingOrg';
import { DependencyWheelError } from './faces/DependencyWheelError';
import { TreemapError } from './faces/TreemapError';
import { DependencyMatrixError as DoqDependencyMatrixError } from './faces/DependencyMatrixError';
import { BubbleChartError as DoqFaceBubbleChartError } from './faces/BubbleChartError';
import { CapabilityMapError as DoqCapabilityMapError } from './faces/CapabilityMapError';
import { ComponentMatrixError as DoqComponentMatrixError } from './faces/ComponentMatrixError';
import { ComponentTreeError as DoqComponentTreeError } from './faces/ComponentTreeError';
import { PageViewError as DoqPageViewError } from './faces/PageViewError';
import { ReferenceTableError as DoqReferenceTableError } from './faces/ReferenceTableError';
import { SwimlaneError as DoqSwimlaneError } from './faces/SwimlaneError';
import { TableError as DoqTableError } from './faces/TableError';
import { TagscapeError as DoqTagscapeError } from './faces/TagscapeError';
import { TimelineError as DoqTimelineError } from './faces/TimelineError';
import { DropzoneInitial as DoqDropzoneInitial } from './faces/DropzoneInitial';
import { DropzoneInvalid as DoqDropzoneDragover } from './faces/DropzoneDragover';
import { DropzoneUploading as DoqDropzoneUploading } from './faces/DropzoneUploading';
import { DropzoneSuccess as DoqDropzoneSuccess } from './faces/DropzoneSuccess';
import { DropzoneInvalid as DoqDropzoneInvalid } from './faces/DropzoneInvalid';
import { DropzoneError as DoqDropzoneError } from './faces/DropzoneError';
import { DoqNoAccess } from './faces/NoAccess';
import { DoqWaiting } from './faces/DoqWaiting';
import { DoqImportSuccess } from './faces/ImportSuccess';
import { Headphones } from './faces/Headphones';
import { exhaustiveCheck } from '@ardoq/common-helpers';
import { EmptyBox } from './faces/EmptyBox';

const getDoqFace = (doqType: DoqType) => {
  switch (doqType) {
    case DoqType.SIMPLE:
      return DoqFaceSimple;
    case DoqType.ALGORITHM:
      return DoqFaceAlgorithm;
    case DoqType.ERROR:
      return DoqFaceError;
    case DoqType.BROADCAST:
      return DoqFaceBroadcast;
    case DoqType.SUCCESS:
      return DoqFaceSuccess;
    case DoqType.ALARM:
      return DoqFaceAlarm;
    case DoqType.LOCKED:
      return DoqFaceLocked;
    case DoqType.DEPENDENCY_MAP_ERROR:
      return DoqDependencyMapError;
    case DoqType.BLOCK_DIAGRAM_ERROR:
      return DoqBlockDiagramError;
    case DoqType.RELATIONSHIPS_ERROR:
      return DoqRelationshipsError;
    case DoqType.PAGE_GONE:
      return DoqPageGone;
    case DoqType.COMPONENT_MERGE_EMPTY:
      return DoqComponentMergeEmpty;
    case DoqType.CHOOSE_ORG:
      return DoqChooseOrg;
    case DoqType.MISSING_ORG:
      return DoqMissingOrg;
    case DoqType.RELATIONSHIPS_GONE:
      return DoqRelationshipsGone;
    case DoqType.DEPENDENCY_MAP_GONE:
      return DoqDependencyMapGone;
    case DoqType.SPIDER_CHART:
      return SpiderChart;
    case DoqType.DASHBOARD_BELLY_SIMPLE:
      return DashboardBellySimple;
    case DoqType.DASHBOARD_BELLY_MISSING_ORG:
      return DashboardBellyMissingOrg;
    case DoqType.DEPENDENCY_WHEEL_ERROR:
      return DependencyWheelError;
    case DoqType.TREEMAP_ERROR:
      return TreemapError;
    case DoqType.DEPENDENCY_MATRIX_ERROR:
      return DoqDependencyMatrixError;
    case DoqType.BUBBLE_CHART_ERROR:
      return DoqFaceBubbleChartError;
    case DoqType.CAPABILITY_MAP_ERROR:
      return DoqCapabilityMapError;
    case DoqType.COMPONENT_MATRIX_ERROR:
      return DoqComponentMatrixError;
    case DoqType.COMPONENT_TREE_ERROR:
      return DoqComponentTreeError;
    case DoqType.PAGE_VIEW_ERROR:
      return DoqPageViewError;
    case DoqType.NO_ACCESS:
      return DoqNoAccess;
    case DoqType.REFERENCE_TABLE_ERROR:
      return DoqReferenceTableError;
    case DoqType.SWIMLANE_ERROR:
      return DoqSwimlaneError;
    case DoqType.TABLE_ERROR:
      return DoqTableError;
    case DoqType.TAGSCAPE_ERROR:
      return DoqTagscapeError;
    case DoqType.TIMELINE_ERROR:
      return DoqTimelineError;
    case DoqType.DROPZONE_INITIAL:
      return DoqDropzoneInitial;
    case DoqType.DROPZONE_DRAGOVER:
      return DoqDropzoneDragover;
    case DoqType.DROPZONE_UPLOADING:
      return DoqDropzoneUploading;
    case DoqType.DROPZONE_SUCCESS:
      return DoqDropzoneSuccess;
    case DoqType.DROPZONE_INVALID:
      return DoqDropzoneInvalid;
    case DoqType.DROPZONE_ERROR:
      return DoqDropzoneError;
    case DoqType.WAITING:
      return DoqWaiting;
    case DoqType.IMPORT_SUCCESS:
      return DoqImportSuccess;
    case DoqType.HEADPHONES:
      return Headphones;
    case DoqType.EMPTY_BOX:
      return EmptyBox;
    default:
      return exhaustiveCheck(doqType);
  }
};

type DoqFaceProps = {
  doqType?: DoqType;
  doqSize?: DoqSize;
  isAnimated?: boolean;
};

const DoqFace = ({
  doqType = DoqType.SIMPLE,
  doqSize = DoqSize.SMALL,
  isAnimated = false,
  ...rest
}: DoqFaceProps) => {
  const DoqFaceComponent = getDoqFace(doqType);
  return <DoqFaceComponent size={doqSize} isAnimated={isAnimated} {...rest} />;
};

export { DoqFace };
